export default __webpack_public_path__ + "static/media/photo--sm--group-close.28cee872.jpg";